import { httpPost, httpPatchMerge, httpDelete } from './http'
import type { TEntityId } from '~/types/models'
import type { ICompanyMSTeamMember } from '~/types/company/models'

const apiEntityPath = '/api/companymsteammembers'

export async function createCompanyMSTeamMember(entity: ICompanyMSTeamMember) {
  const callingMn = createCompanyMSTeamMember.name
  const apiPath = apiEntityPath
  return httpPost<ICompanyMSTeamMember>({
    callingMn,
    apiPath,
    entity,
  })
}

export async function updateCompanyMSTeamMember(
  entityData: Partial<ICompanyMSTeamMember>,
  id: TEntityId
) {
  const callingMn = updateCompanyMSTeamMember.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialCompanyMSTeamMember = Partial<ICompanyMSTeamMember>
  return httpPatchMerge<TPartialCompanyMSTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCompanyMSTeamMember(
  entityData: ICompanyMSTeamMember
) {
  const callingMn = deleteCompanyMSTeamMember.name
  const apiPath = apiEntityPath
  return httpDelete<ICompanyMSTeamMember>({
    callingMn,
    apiPath,
    entityData,
  })
}
